import { createSlice } from "@reduxjs/toolkit";
import { uploadPrescription } from "../../reducer/uploadPrescription/uploadPrescriptionReducer";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const uploadPrescriptionSlice = createSlice({
  name: "uploadPrescription",
  initialState,
  reducers: {
    resetUploadPrescription: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // UPLOAD PRESCRIPTION
      .addCase(uploadPrescription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadPrescription.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadPrescription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUploadPrescription } = uploadPrescriptionSlice.actions;

export default uploadPrescriptionSlice.reducer;
